import React, { Fragment } from 'react';
import Grid from '@material-ui/core/Grid';
import HistoryDisplayContainer from 'src/ui/library/HistoryDisplay';
import ProfileTabPres from './ProfileTabPres';
import ProfileInfoContainer from '../containers/ProfileInfoContainer';
import RelatedEntitiesLanding from 'src/ui/library/RelatedEntities';
import Avatar from 'src/ui/library/Avatar';

export default function ProfilePres(props) {
  const { tab, name, initials, getAdditionalPropsForRelatedEntities, relatedTabs, profileId } = props;

  return (
    <Fragment>
      <div className="profile-header">
        <Grid container className="header-grid" spacing={0}>
          <Grid item xs={1}>
            <HistoryDisplayContainer history={props.history} type={'white'} />
          </Grid>
          <Grid item xs={11}>
            <div className="profile-name-wrapper">
              <div className="profile-initials">
                <Avatar
                  key={profileId}
                  person={{ id: profileId, type: 'contact' }}
                  altText="Profile"
                  renderFallback={() => <span>{initials}</span>}
                />
              </div>
              <div className="profile-name">{name}</div>
            </div>
          </Grid>
        </Grid>
      </div>
      <Grid container className="profile-content" spacing={0}>
        <Grid item xs={12} className="profile-tabs">
          <ProfileTabPres tab={tab} onChange={props.handleTabSelect} relatedTabs={relatedTabs} />
        </Grid>
        <Grid item xs={12} className="profile-body">
          {tab === 'Information' && <ProfileInfoContainer {...props} />}
          {tab !== 'Information' && (
            <RelatedEntitiesLanding
              key={tab}
              topLevelRecordId={profileId}
              parentRecordId={profileId}
              parentEntitySetName="contacts"
              parentEntityName="contact"
              relationshipName={relatedTabs[tab].relationshipName}
              displayName={relatedTabs[tab].displayName}
              additionalProps={getAdditionalPropsForRelatedEntities(relatedTabs[tab].relationshipName)}
              getAdditionalPropsForRelatedEntities={getAdditionalPropsForRelatedEntities}
              area="profile"
            />
          )}
        </Grid>
      </Grid>
    </Fragment>
  );
}
